import React from 'react'

export default function KnowAsServiceHeader({content}) {
  return (
    <div className='knowAsHeaderContainer'>
      <div className='knowAsHeaderTxt'>
        {content}
      </div>
    </div>
  )
}
